import axios from 'axios'
import {clarify} from "@/utils/clear";

class ProductCategoryApi {
  constructor() {
    this.endpoint = process.env.VUE_APP_BASE_API
  }

  /* eslint-disable no-unused-vars */
  list(body) {
    let params = new URLSearchParams(body ? clarify(body) : body)
    return axios.get(`${this.endpoint}/products/categories`, {params}).then(response => response.data)
  }

  save(category) {
    return axios.post(`${this.endpoint}/products/categories/save`, category).then(response => response.data)
  }

  delete(categoryId) {
    return axios.delete(`${this.endpoint}/products/categories/delete/${categoryId}`, {}).then(response => response.data)
  }

  move(move, destination, position) {
    let param = {
      move: move,
      destination: destination,
      position: position
    }
    axios.put(`${this.endpoint}/products/categories/move`, param).then(response=>response.data);
  }

}


export default new ProductCategoryApi()
